// extracted by mini-css-extract-plugin
module.exports = {"pagination":"PlayerInterestsPage_pagination__og7Z_"};